import { createApp } from 'vue'
import App from './App.vue'
import router from  './router'
import './assets/common.css'
import store from './store'
import axios from "axios";

const app = createApp(App)

app.use(store).use(router)

app.provide(axios, app.config.globalProperties.axios)

app.mount('#app')
